import React from 'react';
import { makeComponent } from '../../fanes/make-component';

export type RowProps = {
  children?: React.ReactNode | React.ReactNode[];
};
export const RowToken = 'layout.row';

export const Row = makeComponent<RowProps>(RowToken);
